import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "slug"]

  connect() {
    this.syncEnabled = this.shouldStartSynced()

    if (this.syncEnabled && this.slugTarget.value.trim() === "" && this.titleTarget.value.trim() !== "") {
      this.updateSlugFromTitle()
    }
  }

  titleChanged() {
    if (!this.syncEnabled) {
      return
    }

    this.updateSlugFromTitle()
  }

  slugChanged() {
    if (this.updatingSlug) {
      return
    }

    this.syncEnabled = this.slugTarget.value === this.slugify(this.titleTarget.value)
  }

  shouldStartSynced() {
    const title = this.titleTarget.value
    const slug = this.slugTarget.value

    return slug.trim() === "" || slug === this.slugify(title)
  }

  updateSlugFromTitle() {
    this.updatingSlug = true
    this.slugTarget.value = this.slugify(this.titleTarget.value)
    this.updatingSlug = false
  }

  slugify(value) {
    return value
      .toString()
      .normalize("NFKD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
  }
}
